export interface ResetStandardsForFormNewFromExistingActionType {
  type: '@formNewFromExisting/RESET_STANDARDS';
}

export const resetStandardsForFormNewFromExisting = (): ResetStandardsForFormNewFromExistingActionType => ({
  type: '@formNewFromExisting/RESET_STANDARDS',
});
